var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      style: _vm.setStyle,
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": _vm.imgName,
        role: "presentation",
        preserveAspectRatio: "none"
      }
    },
    [
      !!_vm.imgName
        ? _c("title", { attrs: { id: _vm.imgName, lang: "fr" } }, [
            _vm._v(_vm._s(_vm.$l10n.__(_vm.imgName + "-img-svg")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }